// extracted by mini-css-extract-plugin
module.exports = {"Part3":"Part3_Part3__fNjuw"};